import { Text, Tooltip } from '@elkaso-app/web-design';

interface ITruncatedTextCell {
  value: string | null;
  maxW?: string;
}

// One-line clamp with the full value on hover — keeps free-text columns
// (category, MOQ, delivery, payment terms) from stretching the table.
export const TruncatedTextCell = ({ value, maxW = '160px' }: ITruncatedTextCell) => {
  if (!value) return <Text color='gray.400'>—</Text>;

  return (
    <Tooltip label={value} openDelay={300} hasArrow placement='top'>
      <Text noOfLines={1} maxW={maxW} wordBreak='break-all'>
        {value}
      </Text>
    </Tooltip>
  );
};
